export function atLocalMidnight(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const da = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${da}`;
}

export function computeNextDue(
  schedule: any | undefined,
  fromISO?: string,
  lastCheckinAt?: string,
): string | undefined {
  if (!schedule?.remindersEnabled) return undefined;
  const cadence = schedule?.cadence || 'weekly';
  const today = fromISO ? new Date(fromISO + 'T00:00:00') : new Date();

  // Start from either last check-in or today, whichever is more recent
  let startFrom: Date;
  if (lastCheckinAt) {
    const datePart = lastCheckinAt.includes('T') ? lastCheckinAt.split('T')[0] : lastCheckinAt;
    const lastCheckin = new Date(datePart + 'T00:00:00');
    // Use the more recent date between last check-in and today to ensure future dates
    startFrom = lastCheckin > today ? lastCheckin : today;
  } else {
    startFrom = schedule?.startDateISO ? new Date(schedule.startDateISO + 'T00:00:00') : today;
  }

  const ref = atLocalMidnight(startFrom);
  const start = schedule?.startDateISO ? new Date(schedule.startDateISO + 'T00:00:00') : ref;

  if (cadence === 'weekly' || cadence === 'biweekly' || cadence === 'custom') {
    const days: number[] =
      Array.isArray(schedule?.daysOfWeek) && schedule.daysOfWeek.length
        ? schedule.daysOfWeek.map((n: any) => Number(n)).filter((n: number) => n >= 0 && n <= 6)
        : [1]; // default Monday

    // If we have a last check-in, start searching from the day after
    const searchStart = lastCheckinAt
      ? new Date(ref.getTime() + 86400000) // Add 1 day
      : ref;

    // Find next weekday >= searchStart
    for (let i = 0; i < (cadence === 'biweekly' ? 14 : 7); i++) {
      const d = new Date(searchStart);
      d.setDate(searchStart.getDate() + i);
      if (d < start) continue;
      if (days.includes(d.getDay())) return toISODate(d);
    }
    // Fallback: next week cycle
    const jump = cadence === 'biweekly' ? 14 : 7;
    const d = new Date(searchStart);
    d.setDate(searchStart.getDate() + jump);
    return toISODate(d);
  }

  if (cadence === 'monthly') {
    const dom: number[] =
      Array.isArray(schedule?.daysOfMonth) && schedule.daysOfMonth.length
        ? schedule.daysOfMonth.map((n: any) => Number(n)).filter((n: number) => n >= 1 && n <= 31)
        : [1];

    // If we have a last check-in, start searching from the day after
    const searchStart = lastCheckinAt
      ? new Date(ref.getTime() + 86400000) // Add 1 day
      : ref;

    for (let i = 0; i < 62; i++) {
      // within two months
      const d = new Date(searchStart);
      d.setDate(searchStart.getDate() + i);
      if (d < start) continue;
      if (dom.includes(d.getDate())) return toISODate(d);
    }
    const d = new Date(searchStart);
    d.setMonth(d.getMonth() + 1);
    d.setDate(dom[0]);
    return toISODate(d);
  }
  return toISODate(ref);
}

export function isDueToday(goal: any, todayISO: string): boolean {
  const due = goal?.nextDueOn;
  const active = goal?.status === 'active';
  if (!active || !due) return false;
  return String(due) === String(todayISO);
}
